import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ConditionalIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Conditional",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.33 18.8h-1.68v-6.16c0-.92-.76-1.67-1.68-1.67h-7.28V6.5h3.92c.93 0 1.68-.75 1.68-1.68s-.75-1.68-1.68-1.68h-11.2c-.93 0-1.68.75-1.68 1.68s.75 1.68 1.68 1.68h3.92v4.47H7.05c-.93 0-1.68.75-1.68 1.68v6.16H3.69c-.92 0-1.67.75-1.67 1.67v6.72c0 .93.75 1.69 1.67 1.69h6.73c.93 0 1.68-.75 1.68-1.68v-6.73c0-.93-.75-1.68-1.68-1.68H8.74v-4.47H23.3v4.47h-1.68c-.93 0-1.68.75-1.68 1.68v6.72c0 .93.75 1.68 1.68 1.68h6.72c.93 0 1.68-.75 1.68-1.68v-6.72c0-.92-.75-1.67-1.67-1.67ZM8.72 25.53H5.36v-3.36h3.36zm17.89 0h-3.33v-3.36h3.36l-.04 3.36Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M11 28H5c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1m-5-2h4v-4H6zM27 28h-6c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1m-5-2h4v-4h-4z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M24 22c-.55 0-1-.45-1-1v-6H9v6c0 .55-.45 1-1 1s-1-.45-1-1v-7c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v7c0 .55-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16 15c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v9c0 .55-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21 6H11c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1"
      })]
    })
  }));
};